var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("p", { style: _vm.title.getStyle() }, [
      _vm._v(" " + _vm._s(_vm.$ct("title")) + " "),
    ]),
    _c("p", { style: _vm.text.getStyle() }, [
      _vm._v(" " + _vm._s(_vm.$ct("text")) + " "),
    ]),
    _c("p", { style: _vm.signature.getStyle() }, [
      _vm._v(" " + _vm._s(_vm.$ct("signature")) + " "),
    ]),
    _c("p", { style: _vm.date.getStyle() }, [
      _vm._v(" " + _vm._s(_vm.$ct("date")) + " "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }